export interface SharedFolderQuota {
  id: string;
  title: string;
  colorKey: string;
  role: "owner" | "editor" | "viewer";
  sizeBytes: number;
  locked: boolean;
}

export interface QuotaInfo {
  /** Total: personal plus every shared folder (each member pays full size). */
  usedBytes: number;
  quotaBytes: number;
  attachmentBytes: number;
  noteBytes: number;
  overQuota: boolean;
  premium: boolean;
  personal?: { attachmentBytes: number; noteBytes: number; totalBytes: number };
  sharedFolders?: SharedFolderQuota[];
}

export async function fetchQuota(): Promise<QuotaInfo | null> {
  try {
    const res = await fetch("/api/quota");
    if (!res.ok) return null;
    return (await res.json()) as QuotaInfo;
  } catch {
    return null;
  }
}

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}
